import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const AlignRight = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M17 10h9c0.552 0 1 0.447 1 1v10c0 0.553-0.448 1-1 1h-10c-0.552 0-1-0.447-1-1v-10c0-0.553 0.448-1 1-1h1zM26.086 24.917c0.524 0 0.95 0.425 0.95 0.95v0.1c0 0.524-0.426 0.95-0.95 0.95h-20.022c-0.524 0-0.95-0.426-0.95-0.95v-0.1c0-0.525 0.426-0.95 0.95-0.95h20.022zM7.758 18.172l1.17-1.172h-4.928c-0.552 0-1-0.447-1-1s0.448-1 1-1h4.83l-1.072-1.070c-0.39-0.392-0.39-1.025 0-1.415s1.023-0.39 1.414 0l2.828 2.828c0.39 0.39 0.39 1.024 0 1.415l-2.828 2.828c-0.39 0.39-1.024 0.39-1.414 0s-0.39-1.023 0-1.414zM5.986 7c-0.524 0-0.95-0.426-0.95-0.95v-0.1c0-0.524 0.426-0.95 0.95-0.95h20.022c0.524 0 0.95 0.426 0.95 0.95v0.1c0 0.524-0.426 0.95-0.95 0.95h-20.022z" />
  </SvgIcon>
);

export default AlignRight;
